module.exports = __webpack_public_path__ + "static/img/015.b0df016a.png";